import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const ReceiverGlyph = /*#__PURE__*/createElement("g", {
  id: "receiver"
}, /*#__PURE__*/createElement("path", {
  d: "M42 63.7c-8.74 0-15.33-3.3-15.33-7.67V27.52c0-4.42 6.59-7.71 15.33-7.71s15.33 3.3 15.33 7.67v28.51c0 4.41-6.59 7.71-15.33 7.71zM29.67 43.75v12.24c0 1.99 4.69 4.71 12.33 4.71s12.33-2.72 12.33-4.67V27.52c0-1.99-4.69-4.71-12.33-4.71s-12.33 2.72-12.33 4.67v16.27z"
}), /*#__PURE__*/createElement("path", {
  d: "M55.83 46.66v.03-.59 10.94c0 2.61-6.19 4.73-13.83 4.73s-13.83-2.12-13.83-4.73V46.11v.59-.03M43.5 21.8h-3v-4.62h-6.33v-3h9.33zm6.33 48.02H40.5V62.2h3v4.62h6.33z"
}));
const Receiver = createSvg({
  name: 'receiver',
  path: ReceiverGlyph
});

export default Receiver;
export { ReceiverGlyph };
